import React, { Component } from "react";
import { Select } from "antd";
import { ICONS, SvgIcon } from "../Common/Icons";
import moment from "moment";
import collaboratorApi from "../../services/CollaboratorServices";
import _ from "i18n";

const { Option } = Select;

export class CollaboratorSpaceAddToCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      error: false,
      loading: true
    };
  }

  componentDidMount() {
    const { events } = this.props;
    let icsContent = this.createICS(events).join("\n");
    let file = new File(
      [icsContent],
      `Calendar-${moment().format("YYYY-MM-DD-HH:MM:SS")}.ics`,
      {
        type: "text/calendar;charset=utf-8"
      }
    );
    collaboratorApi
      .uploadIcsFile(file)
      .then(response => {
        this.setState({
          data: response.data.data,
          loading: false
        });
      })
      .catch(error => {
        this.setState({
          error: true,
          loading: false
        });
      });
  }

  handleChangeServices = value => {
    const { events } = this.props;
    switch (value) {
      case "Google":
        return window.open(
          this.getGoogleUrl(events),
          "_blank",
          "noopener,noreferrer"
        );
      case "Outlook":
        return window.open(
          this.getOutlookUrl(events, "live"),
          "_blank",
          "noopener,noreferrer"
        );
      case "Office365":
        return window.open(
          this.getOutlookUrl(events, "office"),
          "_blank",
          "noopener,noreferrer"
        );
      default:
        let url = this.getICalUrl(events);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Calendar-${moment().format("YYYY-MM-DD-HH:MM:SS")}.ics`
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    }
  };

  formatTime = date => {
    const formattedDate = moment(date)
      .utc()
      .format("YYYYMMDDTHHmmssZ");
    return formattedDate.replace("+00:00", "Z");
  };

  getICalUrl = calendarData => {
    const icsContent = this.createICS(calendarData).join("\n");
    const blob = new Blob([icsContent], {
      type: "text/calendar;charset=utf-8"
    });
    return window.URL.createObjectURL(blob);
  };

  getGoogleUrl = calendarData => {
    const { data } = this.state;
    const { isMulti } = this.props;
    const BASE_URL = "https://calendar.google.com/calendar";
    let icsFileUrl = "";

    if (isMulti) {
      icsFileUrl = data.filePath.replace(/^https:\/\//i, "http://");
      return BASE_URL + "?cid=" + icsFileUrl + "&pli=1";
    }

    const startDate = this.formatTime(calendarData[0].date);
    const endDate = this.formatTime(calendarData[0].date);

    const args = {
      action: "TEMPLATE",
      text: "Présentation de " + calendarData[0].clientName,
      dates: `${startDate}/${endDate}`,
      //details: removeMd(description, { stripListLeaders: false }),
      ctz: ""
    };

    const urlSearchParams = new URLSearchParams(args);
    return BASE_URL + "/event?" + urlSearchParams.toString();
  };
  getOutlookUrl = (calendarData, accountType: "live" | "office") => {
    const { data } = this.state;
    const { isMulti } = this.props;
    const BASE_URL =
      accountType === "office"
        ? "https://outlook.office.com/calendar/0"
        : "https://outlook.live.com/calendar/0";
    let icsFileUrl = "";
    if (isMulti) {
      icsFileUrl = data.filePath;
      return BASE_URL + "/addfromweb?url=" + icsFileUrl + `&name=Présentations`;
    }

    const startDate = moment.utc(calendarData[0].date).format();
    const endDate = moment.utc(calendarData[0].date).format();

    const args = {
      path: "/calendar/action/compose",
      rru: "addevent",
      startdt: startDate,
      enddt: endDate,
      subject: "Présentation de " + calendarData[0].clientName,
      location: calendarData[0].date
      //body: removeMd(description, { stripListLeaders: false })
    };

    const urlSearchParams = new URLSearchParams(args);
    return BASE_URL + "/deeplink/compose?" + urlSearchParams.toString();
  };
  createICS = events => {
    let icsCalEvents = [];
    let calName = `Présentations-${moment().format("YYYY-MM-DD-HH:MM:SS")}.ics`;
    events.map(event => {
      let endTime =
        moment(event.date).format("YYYYMMDD") +
        "T" +
        moment(event.date)
          .add(0.3, "hours")
          .format("HHMMSS") +
        "Z";

      icsCalEvents = [
        ...icsCalEvents,
        "BEGIN:VEVENT",
        `UID:${event.id}@tamtam.pro`,
        `DTSTAMP:${this.formatTime(event.date)}`,
        `DTSTART:${this.formatTime(event.date)}`,
        `SUMMARY:Présentation de ${event.clientName}`,
        `DTEND:${endTime}`,
        `DESCRIPTION:Présentation de ${event.clientName}`,
        `LOCATION:${"belgique"}`,
        "END:VEVENT"
      ];
    });

    return [
      "BEGIN:VCALENDAR",
      "VERSION:2.0",
      "PRODID:-//pro.tamtam.cal//NONSGML v1.0//EN",
      "METHOD:PUBLISH",
      "CALSCALE:GREGORIAN",
      `NAME:${calName}`,
      `X-WR-CALNAME:${calName}`,
      ...icsCalEvents,
      "END:VCALENDAR"
    ];
  };
  render() {
    const services = [
      { service: "Google", icon: <SvgIcon icon={ICONS.Google} /> },
      { service: "Outlook", icon: <SvgIcon icon={ICONS.Outlook} /> },
      { service: "Office365", icon: <SvgIcon icon={ICONS.Office365} /> },
      { service: "iCal", icon: <SvgIcon icon={ICONS.Calendar} /> }
    ];

    return (
      <Select
        defaultValue={_("addToCalendar")}
        onChange={value => this.handleChangeServices(value)}
        id={"select_ant"}
        style={{
          width: 170,
          color: "white",
          marginLeft: 10,
          fontSize: 13,
          marginBottom: 40
        }}
        disabled={this.props.events.length === 0}
      >
        {services.map(item => {
          return (
            <Option value={item.service}>
              {item.icon} <span>{item.service} </span>
            </Option>
          );
        })}
      </Select>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CollaboratorSpace/CollaboratorSpaceAddToCalendar.js